import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  list: {
    padding: 0,
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}));
